// src/components/ui/Input.js
import { useState } from 'react';
import styled from 'styled-components';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const StyledInput = styled.input`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
  ${(props) => props.$hasToggle && 'padding-right: 38px;'}
  font-size: 1rem;
  font-family: 'Roboto', sans-serif;
  border: none;
  outline: none;

  &:focus {
    border-color: ${(props) => props.theme.colors.primaryBlue};
  }
`;

const InputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
`;

const ToggleButton = styled.button`
  position: absolute;
  right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #888;

  &:hover {
    color: #555;
  }
`;

export default function Input({
  type = 'text',
  disabled = false,
  placeholder,
  value,
  onChange = () => {},
  onKeyDown = () => {},
}) {
  const isPassword = type === 'password';
  const [visible, setVisible] = useState(false);
  const inputType = isPassword ? (visible ? 'text' : 'password') : type;

  const inputEl = (
    <StyledInput
      type={inputType}
      $hasToggle={isPassword}
      disabled={disabled}
      placeholder={placeholder}
      value={value}
      onKeyDown={onKeyDown}
      onChange={(e) => {
        onChange(e.target.value);
      }}
    />
  );

  // 일반 입력은 기존과 동일하게 그대로 렌더
  if (!isPassword) {
    return inputEl;
  }

  // 비밀번호 입력은 우측에 미리보기(눈) 토글 버튼 추가
  return (
    <InputWrapper>
      {inputEl}
      <ToggleButton
        type='button'
        tabIndex={-1}
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? 'Hide password' : 'Show password'}
        title={visible ? 'Hide password' : 'Show password'}
        disabled={disabled}
      >
        {visible ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
      </ToggleButton>
    </InputWrapper>
  );
}
